import styled from 'styled-components';
import { FlexBoxCol, FlexBoxRow } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';
import Throbber from '@ertelecom/ui-react/components/throbber/throbber';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import GridContainerUI from '@ertelecom/ui-react/components/layouts/gridContainer';
import { breakPoints } from '~/src/layout/bundlesLandNew2/styled';

export const Col = styled(FlexBoxCol)`
     z-index: 2;
`;

export const Row = styled(FlexBoxRow)`
    width: 100%;

    @media (max-width: ${breakPoints.tablet}) {
      width: auto;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    background-color: ${COLORS.white};
    padding: 50px 40px 40px 40px;
`;

export const Preloader = styled(Throbber)`
    position: fixed;
    width: 100px;
    height: 100px;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    transform: translate(0, 0);
`;

export const GridContainer = styled(GridContainerUI)`
    background-color: ${COLORS.white};
    border-radius: 32px;
    margin-top: 16px;
    margin-bottom: 100px;

    @media (max-width: ${breakPoints.tablet}) {
        max-width: 800px;
    }
`;
